const CONSTANTS = {
    COUNTRY: {
        SPAIN: 67,
        ITALY: 107
    },
    CONFIGURACION_TICKET: {
        FACTURA_SIMPLIFICADA: 1,
        TICKET_ESTANDAR: 2
    },
    ESTADOS_PEDIDO: {
        PENDIENTE: 1,
        REALIZADO_PENDIENTE: 2,
        RECIBIDO: 3,
        CANCELADO: 4,
        ENCAMINO_ENVIADO: 5
    },
    FORMAS_PAGO: {
        MIXTO: 6,
        TARJETA_REGALO: 10,
        TARJETA_FIDELIDAD: 11,
        EFECTIVO: 1,
        TARJETA: 2,
        VALE: 3,
        TRANSFERENCIA: 4,
        FINANCIERA: 5,
        PAYPAL: 7,
        ONLINE: 8,
        BIZUM: 9,
    },
    FORMAS_PAGO_ECOMMERCE: {
        TARJETA: 1,
        PAYPAL: 2,
        CONTRAREEMBOLSO: 3,
        RECOGIDA_EN_TIENDA: 4,
    },
    PLANES_KOIBOX: {
        CRM: 1,
        CRM_SMS: 5,
        BASIC: 12,
        GOLD: 13,
        PLATINUM: 14,
        LITE: 15
    }
}

export default CONSTANTS
